
const buttons = document.querySelectorAll(".input-info__btn")
window.addEventListener("click", (e) => {
    buttons.forEach(btn => {
        const info = btn.parentElement
        if (e.target === btn.parentElement || e.target === btn) {
            info.classList.toggle("--active");
        }
        else if (e.target === btn.parentElement.querySelector(".input-info__content") || e.target === btn.parentElement.querySelector(".input-info__perex")) {
            return
        } else {
            btn.parentElement.classList.remove("--active");
        }
    });

})
